













import { Component, Mixins } from "vue-property-decorator";
import OrderList from "defi/components/orders/OrderList.vue";
import mixins from "@/mixins";

@Component({
  components: {
    OrderList
  }
})
class Orders extends Mixins(mixins.scrollAppbarPage) {
  get title(): any {
    return this.$t("common.orders");
  }

  get themeColor(): any {
    return "#0596FF";
  }
}
export default Orders;
